<template>
    <div v-loading="loading">
        <div class="light_bg p-4 mt-4 rounded-xl">
            <EmptyRatings v-if="pendingRatings.length < 1 && !loading" />
            <div class="flex flex-wrap items-center my-3 rate_div" v-for="(shipping, index) in pendingRatings"
                :key="index + 'pending_ratings'" v-else-if="pendingRatings.length > 0 && !loading">
                <div class="w-full sm:w-6/12">
                    <b>{{ shipping && shipping.shippingReference ? `#${shipping.shippingReference}` : "N/A" }} |
                        Delivered on {{ formatDate(shipping.deliveredDate) }}</b>
                    <p class="py-1">Dispatcher: {{ shipping && shipping.userToRate ? `${shipping.userToRate.firstname}
                        ${shipping.userToRate.lastname}` : "N/A" }}</p>
                    <p>Delivered To: {{ shipping && shipping.deliveredTo ? shipping.deliveredTo : 'N/A' }}</p>
                </div>
                <div class="w-full sm:w-6/12 flex justify-end items-center">
                    <button @click="viewSummary(shipping)" class="px-4">View Summary</button>
                    <button @click="rateNow(shipping)" class="py-2 px-4 rounded-lg bg-primary-yellow">Rate Now</button>
                </div>
                <hr class="below_line" />
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import EmptyRatings from './empty-ratings.vue';

export default {
    components: {
        EmptyRatings
    },
    props: {
        getRatingTab: {
            type: Function
        }
    },
    data() {
        return {
            pendingRatings: [],
            loading: false
        }
    },
    watch: {},
    mounted() {
        this.getUserPendingRatings()
    },
    computed: {

    },
    methods: {
        viewSummary(shipping) {
            if (!shipping?.shippingId) {
                this.generateToast("No Shipping available to View Summary", "error");
                return;
            }
            this.$router.push({ name: "RatingsDeliverySummary", params: { id: shipping?.shippingId } });
        },
        rateNow(shipping) {
            if (!shipping?.userToRate?.id) {
                this.generateToast("No Dispatcher available to rate", "error");
                return;
            }
            this.$router.push({ name: "BookingFlowRating", params: { id: shipping?.shippingId }, query: { driver: shipping?.userToRate?.id } });
        },
        formatDate(date) {
            return moment(date).format("MMM DD, YYYY")
        },
        async getUserPendingRatings() {
            this.loading = true
            try {
                let response = await this.$_getUserPendingRatings();
                this.pendingRatings = response?.data?.pendingRatings
            } catch (error) {
                //
            } finally {
                this.loading = false
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.below_line {
    @apply w-full bg-transparent border-gray-300 mt-4 mb-2
}

.light_bg {
    @apply bg-primary-blue/5
}

.rate_div:nth-last-of-type(1) {
    hr {
        @apply hidden
    }
}
</style>